/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Queues_Edit_Name_InfoInputs */

const en_forms_queues_edit_name_info = /** @type {(inputs: Forms_Queues_Edit_Name_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The queue name cannot be changed. Please create a new queue with that name instead.`)
};

const de_forms_queues_edit_name_info = /** @type {(inputs: Forms_Queues_Edit_Name_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Name der Queue kann nicht geändert werden. Bitte erstelle stattdessen eine neue Queue mit dem Namen.`)
};

/**
* | output |
* | --- |
* | "The queue name cannot be changed. Please create a new queue with that name instead." |
*
* @param {Forms_Queues_Edit_Name_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_queues_edit_name_info = /** @type {((inputs?: Forms_Queues_Edit_Name_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Queues_Edit_Name_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_queues_edit_name_info(inputs)
	return de_forms_queues_edit_name_info(inputs)
});